import styled from "styled-components";

const InspectionFormConditionsContainer = (props: {
  pdfFileUrl?: string | null;
}) => {
  return props.pdfFileUrl ? (
    <object
      data={props.pdfFileUrl}
      type={"application/pdf"}
      width={"100%"}
      height={"100%"}
      aria-label="pakketvoorwaarden"
    />
  ) : (
    <WarningTextContainer>
      <h3>Geen pakketvoorwaarden beschikbaar.</h3>
    </WarningTextContainer>
  );
};

const WarningTextContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: 12px;
`;

export default InspectionFormConditionsContainer;
